export enum FinishingType {
    ROUGH = 'ROUGH',
    PRE_FINE = 'PRE_FINE',
    FINE = 'FINE',
    TURN_KEY = 'TURN_KEY'
}
